import {
  logger,
  PanelActionOutcome,
  ActionGesture,
  PanelRegion,
  PanelLaunchMethod,
} from "@mwt/web-js-telemetry";

import {
  ScenarioName,
  ScenarioType,
  ModuleName,
  ModuleSummary,
  PanelType,
} from "../telemetry/utils/constants";

/**
 * Log if the session is authorized or not and report the launch source.
 * If there is no launch source (no context recieved) then the session
 * is anonymous
 */

export function logCheckAuthSession() {
  // Check if the launch source exists for current session
  const source = sessionStorage.getItem("launchSource");

  logger.logPanelActionEvent({
    actionScenario: ScenarioName.CheckAuthSession,
    actionScenarioType: ScenarioType.DeviceTestSession,
    actionOutcome: PanelActionOutcome.None,
    actionGesture: ActionGesture.None,
    panelType: PanelType.AuthSession,
    panelRegion: PanelRegion.Main,
    panelLaunchMethod: PanelLaunchMethod.Direct,
    moduleName: source ? ModuleName.AuthSession : ModuleName.AnonymousSession,
    moduleSummary: source
      ? ModuleSummary.AuthSession
      : ModuleSummary.AnonymousSession,
    databag: {
      "DataBag.source": source ?? "Anonymous",
    },
  });
}
